'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { Home, ArrowLeft, Plane } from 'lucide-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface-2 px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-3xl gradient-primary flex items-center justify-center shadow-lg">
            <Plane size={40} className="text-white" />
          </div>
        </div>

        {/* 404 */}
        <h1 className="font-display text-8xl font-800 text-gray-200 leading-none mb-2" style={{ fontWeight: 800 }}>
          404
        </h1>

        <h2 className="font-display text-2xl font-700 text-gray-900 mb-3" style={{ fontWeight: 700 }}>
          Page Not Found
        </h2>
        <p className="text-gray-500 font-body text-sm leading-relaxed mb-8">
          Looks like this destination doesn't exist. Let's get you back on track to explore Algeria.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => router?.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-gray-200 bg-white text-gray-700 font-display font-600 text-sm hover:bg-gray-50 transition-all duration-150 active:scale-95 min-h-[48px]"
            style={{ fontWeight: 600 }}
          >
            <ArrowLeft size={16} />
            Go Back
          </button>

          <button
            onClick={() => router?.push('/')}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-white font-display font-600 text-sm hover:bg-primary-600 transition-all duration-150 active:scale-95 shadow-sm min-h-[48px]"
            style={{ fontWeight: 600 }}
          >
            <Home size={16} />
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}